import { useEffect, React } from "react";
import "../styles/home.css";
import "..//styles/header.css";
import Layout from "../tools/layout.js";
import MathFunctionsShowcase from "../components/calculs/functions.js";
import AnimatedTitle from "../components/animated-title/animated-title.js";

function Home() {
  useEffect(() => {
    document.title = "Home | Ion Niculica";
  }, []);

  return (
    <Layout>
      <section className="home">
        <div className="home-container">
          <AnimatedTitle as="h1">
          How can I use engineering 
          <br/>to make <span>life better—not just easier</span>?
          </AnimatedTitle>

          <div className="home-content">
            <div className="the-idea">
              <p>
                I started in engineering—studies for a way to make things useful.
                That studies led me here.
                The same curiosity that asks “how does it work?” must ultimately ask “who is it for?”
              </p>
              <p>
                We live in a world full of solutions. Systems are built, technologies evolve, and innovation moves fast. But the real question isn’t how much we can build—it’s whether we are building what truly matters.
                I believe engineering is not just about solving problems, but about understanding needs. Real needs. The ones that don’t always appear in data, but in people’s lives.
              </p>
              <p>
                I want to build systems that make things more accessible, more meaningful, and more human. Not just technology for progress, but technology with purpose—solutions that reach further, especially where they are needed most.
              </p>
              <p>
                But building it right takes more than technical skill. It takes awareness, responsibility, and a deep sense of care. It takes people who think beyond systems—builders, thinkers, and those who quietly choose to make a difference.
                There is so much to build.
                If you share this vision, let’s get to work.
              </p>
              <p>The world is full of challenges.
                But there is potential everywhere.
                And the future is still ours to design.
              </p>
            </div>
            <AnimatedTitle>The Expedition</AnimatedTitle>
            <p>
              Focusing on what matters is a process. Not something achieved overnight, but something built step by step.

              Right now, I’m at the beginning. Building knowledge, learning fundamentals, trying, failing, and learning again. Not rushing to the destination, but understanding the path.

              For now, I only have a computer, some tools, and a growing curiosity. But every system starts small. Every idea begins with something simple.

              So I keep building.
              And I’ll see where it takes me.

            </p>

          </div>
          <div className="maths-container">
            <p className="maths-functions">Mathematical functions illustrating the rhythms and patterns of life.</p>
            <MathFunctionsShowcase />
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Home;